import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

export const createTrade = createAsyncThunk(
  "trade/createTrade",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/mcoupon/api/v1/transactions`, data);
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const priviewMoney = createAsyncThunk(
  "trade/priviewMoney",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(
        `/mcoupon/api/v1/transactions/real-revenue`,
        data
      );
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getListHistory = createAsyncThunk(
  "trade/getListHistory",
  async ({ currentPage, pageSize, value }, { rejectWithValue }) => {
    try {
      const apiUrl =
        value === undefined
          ? `/mcoupon/api/v1/transactions?has_paginate&page=${currentPage}&size=${pageSize}`
          : `/mcoupon/api/v1/transactions?search=${value}&has_paginate&size=${pageSize}&page=${currentPage}`;
      const response = await http.get(apiUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getListDetailHistory = createAsyncThunk(
  "trade/getListDetailHistory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.get(`/mcoupon/api/v1/transactions/${id}`);
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getPointCustomer = createAsyncThunk(
  "trade/getPointCustomer",
  async ({ branch_id, customer_id }) => {
    try {
      const response = await http.get(
        `/mcoupon/api/v1/transactions/customer-point?branch_id=${branch_id}&customer_id=${customer_id}`
      );
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);
export const getListVoucherTrade = createAsyncThunk(
  "trade/getListVoucherTrade",
  async ({ branch_id, customer_id }) => {
    try {
      const response = await http.get(
        `/mcoupon/api/v1/coupon-codes/coupon-by-customer?branch_id=${branch_id}&customer_id=${customer_id}`
      );
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);
export const previewTradeByQuantity = createAsyncThunk(
  "trade/previewTradeByQuantity",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(
        `/api/v1/shinko/trade/by-quantity/preview`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);
export const createTradeByQuantity = createAsyncThunk(
  "trade/createTradeByQuantity",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(
        `/api/v1/shinko/trade/by-quantity`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);
export const checkVoucher = createAsyncThunk(
  "trade/checkVoucher",
  async (data) => {
    try {
      const response = await http.post(
        `/mcoupon/api/v1/transactions/check-coupon`,
        data
      );
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);
